import { NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Component, ChangeDetectionStrategy, Input, HostBinding, ContentChild } from '@angular/core';

/** Using to display content on the left side */
const _c0 = ["ng-doc-text", ""];
const _c1 = ["*", [["", "ngDocTextLeft", ""]], [["", "ngDocTextRight", ""]]];
const _c2 = ["*", "[ngDocTextLeft]", "[ngDocTextRight]"];
function NgDocTextComponent_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function NgDocTextComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
let NgDocTextLeftDirective = /*#__PURE__*/(() => {
  class NgDocTextLeftDirective {
    static {
      this.ɵfac = function NgDocTextLeftDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocTextLeftDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocTextLeftDirective,
        selectors: [["", "ngDocTextLeft", ""]],
        standalone: true
      });
    }
  }
  return NgDocTextLeftDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Using to display content on the right side */
let NgDocTextRightDirective = /*#__PURE__*/(() => {
  class NgDocTextRightDirective {
    static {
      this.ɵfac = function NgDocTextRightDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocTextRightDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocTextRightDirective,
        selectors: [["", "ngDocTextRight", ""]],
        standalone: true
      });
    }
  }
  return NgDocTextRightDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgDocTextComponent = /*#__PURE__*/(() => {
  class NgDocTextComponent {
    constructor(changeDetectorRef) {
      this.changeDetectorRef = changeDetectorRef;
      /** Text size */
      this.size = 'medium';
      /** Text color */
      this.color = 'normal';
      /** Text align */
      this.align = 'left';
      this.absoluteContent = false;
      this.ngDocElement = true;
    }
    ngAfterContentChecked() {
      this.changeDetectorRef.detectChanges();
    }
    static {
      this.ɵfac = function NgDocTextComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocTextComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocTextComponent,
        selectors: [["", "ng-doc-text", ""]],
        contentQueries: function NgDocTextComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, NgDocTextLeftDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, NgDocTextRightDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.leftContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rightContent = _t.first);
          }
        },
        hostVars: 6,
        hostBindings: function NgDocTextComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-text-size", ctx.size)("data-ng-doc-text-color", ctx.color)("data-ng-doc-text-align", ctx.align)("data-ng-doc-text-absolute", ctx.absoluteContent);
            i0.ɵɵclassProp("ngde", ctx.ngDocElement);
          }
        },
        inputs: {
          size: "size",
          color: "color",
          align: "align",
          absoluteContent: "absoluteContent"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        attrs: _c0,
        ngContentSelectors: _c2,
        decls: 4,
        vars: 2,
        consts: [["class", "ng-doc-text-left", 4, "ngIf"], [1, "ng-doc-text"], ["class", "ng-doc-text-right", 4, "ngIf"], [1, "ng-doc-text-left"], [1, "ng-doc-text-right"]],
        template: function NgDocTextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵtemplate(0, NgDocTextComponent_span_0_Template, 2, 0, "span", 0);
            i0.ɵɵelementStart(1, "span", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, NgDocTextComponent_span_3_Template, 2, 0, "span", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.leftContent);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.rightContent);
          }
        },
        dependencies: [NgIf],
        styles: [":root{--ng-doc-text-left-width: auto;--ng-doc-text-right-width: auto}[_nghost-%COMP%]{font-family:var(--ng-doc-font-family);font-variant:no-contextual;color:var(--ng-doc-text);line-height:var(--ng-doc-line-height);font-size:var(--ng-doc-font-size);font-weight:var(--ng-doc-font-weight);position:relative;display:flex;align-items:center}[data-ng-doc-text-size=small][_nghost-%COMP%]{--ng-doc-font-size: 14px;--ng-doc-line-height: 18px}[data-ng-doc-text-color=muted][_nghost-%COMP%]{--ng-doc-text: var(--ng-doc-text-muted)}[data-ng-doc-text-align=center][_nghost-%COMP%]   .ng-doc-text[_ngcontent-%COMP%]{text-align:center}[data-ng-doc-text-align=right][_nghost-%COMP%]   .ng-doc-text[_ngcontent-%COMP%]{text-align:right}[data-ng-doc-text-absolute=true][_nghost-%COMP%]   .ng-doc-text-left[_ngcontent-%COMP%]{position:absolute;transform:translate(calc(-100% - var(--ng-doc-base-gutter)))}[data-ng-doc-text-absolute=true][_nghost-%COMP%]   .ng-doc-text-right[_ngcontent-%COMP%]{position:absolute;right:0;transform:translate(calc(100% + var(--ng-doc-base-gutter)))}span[_nghost-%COMP%]{display:inline-flex}span[_nghost-%COMP%]   .ng-doc-text[_ngcontent-%COMP%]{width:auto}[_nghost-%COMP%]   .ng-doc-text-left[_ngcontent-%COMP%], [_nghost-%COMP%]   .ng-doc-text-right[_ngcontent-%COMP%]{display:flex;justify-content:center;flex-shrink:0;min-height:var(--ng-doc-line-height);align-items:center}[_nghost-%COMP%]   .ng-doc-text-left[_ngcontent-%COMP%]    >ng-doc-svg-icon, [_nghost-%COMP%]   .ng-doc-text-right[_ngcontent-%COMP%]    >ng-doc-svg-icon{display:flex;min-height:var(--ng-doc-line-height)}[_nghost-%COMP%]   .ng-doc-text[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .ng-doc-text[_ngcontent-%COMP%]:empty{display:none}[data-ng-doc-text-absolute=false][_nghost-%COMP%]   .ng-doc-text-left[_ngcontent-%COMP%]:not(:empty){width:var(--ng-doc-text-left-width)}[data-ng-doc-text-absolute=false][_nghost-%COMP%]   .ng-doc-text-left[_ngcontent-%COMP%]:not(:empty) ~ .ng-doc-text[_ngcontent-%COMP%]{margin-left:var(--ng-doc-base-gutter)}[data-ng-doc-text-absolute=false][_nghost-%COMP%]   .ng-doc-text-right[_ngcontent-%COMP%]:not(:empty){width:var(--ng-doc-text-right-width);margin-left:var(--ng-doc-base-gutter)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocTextComponent, NgDocTextLeftDirective, NgDocTextRightDirective };
